<div class="chart">
  <brt-pie-chart *ngIf="pieChartData" [data]="pieChartData" (onIndexHover)="onIndexHover.emit($event)" (onIndexHoverOut)="onIndexHoverOut.emit()"></brt-pie-chart>
  <brt-line-chart *ngIf="lineChartData" [data]="lineChartData" [y-label]="'Punkte'"></brt-line-chart>
  <brt-mini-chart *ngIf="miniChartData" [data]="miniChartData"></brt-mini-chart>
</div>
